import React, { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';

import EmailIcon from '@mui/icons-material/Email';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import Chip from '@mui/material/Chip';
import Box  from '@mui/material/Box';


export default function MailboxDialog(props) {

    // 0 = view, 1 = write
    const [writeOrView, setWriteOrView] = React.useState(0);
    const [recipient, setRecipient] = React.useState("");
    const [title, setTitle] = React.useState("");
    const [content, setContent] = React.useState("");

    const [openMail, setOpenMail] = React.useState(false);
    const [mailData, setMailData] = React.useState({"title":"hello", "content":"i see you", "from":"sender"});

    // fetch mail at 

    // function getMail() {
    //     axios.post(Config.getMailurl, {"session_id":Cookies.get('session_id')},
    //     {  crossDomain: true, withCredentials: true, origin: "http://localhost:3000" }
    //   ).then((response) => {
    //       // console.log(response.data.profile_pic);
    //       setProfilePicLink(response.data.profile_pic);
    //       setGivenName(response.data.given_name)
    //     }).catch(function (error) {
    //       console.log(error);
    //     })
    //   }
    
    //   useEffect(() => {
    //     getMail();
    //   }, [])

    return ( 
        <Stack align='center' sx={{height:'100%', alignItems:'center', justifyContent:'center', minWidth:
        '500px'}}>

            <Box>
                <Chip label="View Mail"
                color="primary" variant={writeOrView===1 ? "outlined" : ""}
                onClick={() => setWriteOrView(0)} sx={{margin:1}}  />

                <Chip label="Write Mail" color="primary" variant={writeOrView===0 ? "outlined" : ""}
                onClick={() => setWriteOrView(1)} sx={{margin:1}}/>
            </Box>

            { writeOrView===1 && <div>
            <TextField onChange={(e) => setRecipient(e.target.value)} inputProps={{ maxLength: 20 }} variant="filled" 
                label="Recipient Username" sx={{minWidth: '500px', margin: 1,}} value={recipient} />

            <TextField onChange={(e) => setTitle(e.target.value)} inputProps={{ maxLength: 20 }} variant="filled" 
                label="Title" sx={{minWidth: '500px', margin: 1,}} value={title}/>

            <TextField onChange={(e) => setContent(e.target.value)} inputProps={{ maxLength: 1000 }} variant="filled" 
                helperText="1000 Characters Max" multiline minRows={3} maxRows={10} label="Content" 
                sx={{minWidth: '500px', margin: 1,}} value={content}/>

            <Button
                onClick={() => 0} variant="contained"
                sx={{ margin: 2,}}
            >
                Send Mail
            </Button>
                </div>
            }

            { writeOrView===0 &&
            <List sx={{ width: '100%', minWidth: 360, bgcolor: 'background.paper' }}>
                <ListItemButton onClick={() => setOpenMail(true)}>
                <ListItem >
                    
                    <ListItemAvatar>
                        <EmailIcon/>
                    </ListItemAvatar>
                    <ListItemText
                    primary="hello"
                    secondary="From: David"/>
                </ListItem>
                </ListItemButton>
            </List>
            }

        <Dialog open={openMail} onClose={() => setOpenMail(false)}>            
            <DialogTitle> <ArrowBackOutlinedIcon onClick={() => setOpenMail(false)} />Mail from David</DialogTitle>

            <TextField inputProps={{ maxLength: 20 }} variant="filled" 
                label="Title" sx={{minWidth: '500px', margin: 1,}} value={mailData.title}/>

            <TextField inputProps={{ maxLength: 1000 }} variant="filled" 
                multiline minRows={3} maxRows={10} label="Message" 
                sx={{minWidth: '500px', margin: 1,}} value={mailData.content}/>
        </Dialog>
            

        </Stack>
    )
}